import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/tipoCambio/tipoCambio';
import ListTipoCambio from './TipoCambioList';


const ms2p = (state) => {
  return {
    ...state.tipo_cambio,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListTipoCambio);
